import { createAsyncThunk } from "@reduxjs/toolkit";
import { showToast } from "../../toast/reducer";
import { editUser as editUserAPI, fetchProfile as fetchProfileAPI } from "../../../helpers/apis";

export const editUser = createAsyncThunk(
  "profile/editUser",
  async (data, thunkAPI) => {
    try {
      const response = await editUserAPI(data);
      
      // Handle API response structure: { statusCode, status, message, data }
      if (response && response.status === 1) {
        const message = response.message || "Profile updated successfully";
        thunkAPI.dispatch(showToast({ type: "success", msg: message }));
        return response;
      } else {
        const errorMsg = response?.message || "Failed to update profile";
        thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
        return thunkAPI.rejectWithValue(errorMsg);
      }
    } catch (error) {
      const errorMsg = error?.message || error?.msg || "An error occurred while updating profile";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

export const fetchProfile = createAsyncThunk(
  "profile/fetchProfile",
  async (_, thunkAPI) => {
    try {
      const response = await fetchProfileAPI();

      // Handle API response structure: { statusCode: 200, status: 1, message: "Profile retrieved", data: { user: {...} } }
      if (response && response.status === 1 && response.data && response.data.user) {
        return response; // Return full response to extract user in reducer
      } else {
        const errorMsg = response?.message || "Failed to fetch profile";
        thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
        return thunkAPI.rejectWithValue(errorMsg);
      }
    } catch (error) {
      const errorMsg = error?.message || error?.msg || "An error occurred while fetching profile";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);